var _g, _g2, _g3, _g4, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 88,
    viewBox: "0 0 91 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_721_16779)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18925 24.9295C9.18925 34.5611 17.14 42.2797 27.0614 42.2797C36.9792 42.2797 44.9336 34.5611 44.9336 24.9295C44.9336 15.2979 36.9792 7.57935 27.0614 7.57935C17.14 7.57935 9.18925 15.2979 9.18925 24.9295ZM54.0664 61.9242C54.0664 53.0083 41.6242 50.7776 27.0568 50.7776C12.4102 50.7776 0.0471344 53.0851 0.0471344 62.008C0.0471344 70.924 12.4893 73.1547 27.0568 73.1547C41.7033 73.1547 54.0664 70.8472 54.0664 61.9242Z",
    fill: "url(#paint0_linear_721_16779)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_721_16779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9251 56.496C41.8193 56.496 49.416 57.9775 49.416 63.8988C49.416 69.8248 41.8677 71.3573 32.9251 71.3573C24.0309 71.3573 16.4342 69.8758 16.4342 63.9545C16.4342 58.0285 23.9825 56.496 32.9251 56.496Z",
    fill: "#5F656D",
    fillOpacity: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_721_16779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4268 33.7086C26.4334 33.7086 22.4318 29.7418 22.4318 24.7918C22.4318 19.8418 26.4334 15.875 31.4268 15.875C36.4184 15.875 40.4219 19.8418 40.4219 24.7918C40.4219 29.7418 36.4184 33.7086 31.4268 33.7086Z",
    fill: "#5F656D",
    fillOpacity: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_721_16779)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_721_16779",
    maskUnits: "userSpaceOnUse",
    x: 17.0469,
    y: 0.000244141,
    width: 73,
    height: 88,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 17.0469,
    y: 0.000244141,
    width: 73,
    height: 88
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1214 23.754C30.1214 36.3853 40.5484 46.5077 53.5597 46.5077C66.5663 46.5077 76.998 36.3853 76.998 23.754C76.998 11.1227 66.5663 1.00024 53.5597 1.00024C40.5484 1.00024 30.1214 11.1227 30.1214 23.754ZM89.0469 72.2721C89.0469 60.5794 72.7296 57.6539 53.6253 57.6539C34.4172 57.6539 18.2037 60.6801 18.2037 72.382C18.2037 84.0748 34.5209 87.0002 53.6253 87.0002C72.8334 87.0002 89.0469 83.974 89.0469 72.2721Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1214 23.754C30.1214 36.3853 40.5484 46.5077 53.5597 46.5077C66.5663 46.5077 76.998 36.3853 76.998 23.754C76.998 11.1227 66.5663 1.00024 53.5597 1.00024C40.5484 1.00024 30.1214 11.1227 30.1214 23.754ZM89.0469 72.2721C89.0469 60.5794 72.7296 57.6539 53.6253 57.6539C34.4172 57.6539 18.2037 60.6801 18.2037 72.382C18.2037 84.0748 34.5209 87.0002 53.6253 87.0002C72.8334 87.0002 89.0469 83.974 89.0469 72.2721Z",
    fill: "#5F656D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5597 47.5077C40.0242 47.5077 29.1214 36.9653 29.1214 23.754H31.1214C31.1214 35.8053 41.0725 45.5077 53.5597 45.5077V47.5077ZM77.998 23.754C77.998 36.9654 67.0903 47.5077 53.5597 47.5077V45.5077C66.0423 45.5077 75.998 35.8051 75.998 23.754H77.998ZM53.5597 0.000244141C67.0903 0.000244141 77.998 10.5425 77.998 23.754H75.998C75.998 11.7028 66.0423 2.00024 53.5597 2.00024V0.000244141ZM29.1214 23.754C29.1214 10.5427 40.0242 0.000244141 53.5597 0.000244141V2.00024C41.0725 2.00024 31.1214 11.7027 31.1214 23.754H29.1214ZM53.6253 56.6539C63.1991 56.6539 72.1915 57.3831 78.8213 59.6312C82.1417 60.7571 84.943 62.2877 86.9227 64.3653C88.9256 66.467 90.0469 69.0883 90.0469 72.2721H88.0469C88.0469 69.6096 87.1285 67.4804 85.4749 65.745C83.7981 63.9854 81.3261 62.5924 78.1791 61.5253C71.8742 59.3874 63.1558 58.6539 53.6253 58.6539V56.6539ZM17.2037 72.382C17.2037 69.1982 18.3167 66.5703 20.3098 64.4578C22.2804 62.3689 25.0716 60.8238 28.3863 59.6841C35.0044 57.4085 43.998 56.6539 53.6253 56.6539V58.6539C44.0444 58.6539 35.3272 59.4124 29.0366 61.5754C25.8969 62.6549 23.4342 64.0605 21.7646 65.8302C20.1173 67.5762 19.2037 69.7148 19.2037 72.382H17.2037ZM53.6253 88.0002C44.0515 88.0002 35.0591 87.271 28.4292 85.0229C25.1089 83.8971 22.3076 82.3664 20.3278 80.2888C18.325 78.1871 17.2037 75.5658 17.2037 72.382H19.2037C19.2037 75.0445 20.122 77.1738 21.7757 78.9091C23.4524 80.6687 25.9245 82.0618 29.0715 83.1289C35.3764 85.2667 44.0947 86.0002 53.6253 86.0002V88.0002ZM90.0469 72.2721C90.0469 75.4559 88.9338 78.0838 86.9408 80.1964C84.9701 82.2852 82.179 83.8303 78.8643 84.9701C72.2461 87.2457 63.2525 88.0002 53.6253 88.0002V86.0002C63.2062 86.0002 71.9234 85.2417 78.214 83.0787C81.3536 81.9992 83.8164 80.5937 85.486 78.8239C87.1332 77.0779 88.0469 74.9393 88.0469 72.2721H90.0469Z",
    fill: "url(#paint1_linear_721_16779)",
    mask: "url(#path-4-outside-1_721_16779)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bd_721_16779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5512 27.0255C60.1747 27.6431 60.1747 28.6421 59.5512 29.2578C59.2394 29.5666 58.8359 29.7318 58.4142 29.7318C58.0107 29.7318 57.6073 29.5865 57.2955 29.2578L54.0313 26.0447L50.767 29.2578C50.4552 29.5666 50.0518 29.7318 49.63 29.7318C49.2266 29.7318 48.8048 29.5666 48.493 29.2578C47.8695 28.6421 47.8695 27.6431 48.493 27.0074L51.7573 23.7925L48.493 20.5577C47.8695 19.942 47.8695 18.9248 48.493 18.3073C49.1165 17.6879 50.1252 17.6879 50.767 18.3073L54.0313 21.5385L57.2772 18.3073C57.919 17.6879 58.9276 17.6879 59.5512 18.3073C60.1747 18.9248 60.1747 19.942 59.5512 20.5577L56.2869 23.7925L59.5512 27.0255Z",
    fill: "url(#paint2_linear_721_16779)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4106 29.1155L59.4104 29.1157C59.1355 29.388 58.7823 29.5318 58.4142 29.5318C58.0598 29.5318 57.7108 29.4051 57.4406 29.1202L57.4407 29.1201L57.4358 29.1152L54.1716 25.9022L54.0313 25.7641L53.891 25.9022L50.6267 29.1152L50.6263 29.1157C50.3513 29.388 49.9982 29.5318 49.63 29.5318C49.279 29.5318 48.9078 29.3871 48.6338 29.1157L48.6336 29.1155C48.091 28.5797 48.0873 27.7079 48.6346 27.1486L51.8976 23.935L52.0419 23.793L51.8981 23.6505L48.6338 20.4156L48.6336 20.4154C48.0895 19.8781 48.0892 18.9888 48.6338 18.4494L48.634 18.4492C49.1781 17.9087 50.0617 17.9055 50.6272 18.4504L53.8906 21.6806L54.0317 21.8203L54.1724 21.6802L57.4171 18.4502C57.9827 17.9055 58.8661 17.9088 59.4102 18.4492L59.4104 18.4494C59.955 18.9888 59.9547 19.8781 59.4106 20.4154L59.4104 20.4156L56.1461 23.6505L56.0027 23.7926L56.1462 23.9346L59.4104 27.1676C59.955 27.707 59.9547 28.5782 59.4106 29.1155Z",
    stroke: "url(#paint3_linear_721_16779)",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_721_16779",
    x: -12.9531,
    y: -5.42065,
    width: 80.0195,
    height: 91.5753,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_721_16779"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_721_16779",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_721_16779",
    x: 3.43359,
    y: 43.496,
    width: 58.9824,
    height: 40.8613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_721_16779"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_721_16779",
    x: 7.43164,
    y: 0.875,
    width: 47.9902,
    height: 47.8336,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_721_16779"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_721_16779",
    x: 2.20312,
    y: -14.9998,
    width: 102.844,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_721_16779"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_721_16779",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bd_721_16779",
    x: 33.0254,
    y: 2.84277,
    width: 41.9941,
    height: 41.889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_721_16779"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.807843 0 0 0 0 0.847059 0 0 0 0 0.894118 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_721_16779",
    result: "effect2_dropShadow_721_16779"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_721_16779",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_721_16779",
    x1: 23.0799,
    y1: 44.7582,
    x2: 73.654,
    y2: 65.0151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E757B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F656D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_721_16779",
    x1: 77.7698,
    y1: 11.0194,
    x2: 21.6622,
    y2: 68.2628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_721_16779",
    x1: 59.1685,
    y1: 19.9897,
    x2: 45.8092,
    y2: 20.4291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_721_16779",
    x1: 49.9345,
    y1: 19.2279,
    x2: 57.5043,
    y2: 28.6854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyUsers);
export default __webpack_public_path__ + "static/media/empty-users.1be21229e93a64d9c9d17d8d34b649b7.svg";
export { ForwardRef as ReactComponent };